var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthlyBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "monthly budget") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 51.44v4.56h40v-4.56a13.97 13.97 0 0 0-2.13-7.42l-7.51-12.02 7.51-12.02a13.97 13.97 0 0 0 2.13-7.42v-4.56h-40v4.56a13.97 13.97 0 0 0 2.13 7.42l7.51 12.02-7.51 12.02a13.97 13.97 0 0 0-2.13 7.42z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 4h-44a2 2 0 0 1 0-4h44a2 2 0 0 1 0 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-44a2 2 0 0 1 0-4h44a2 2 0 0 1 0 4z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyBudget);
export default __webpack_public_path__ + "static/media/monthly-budget.c241ce4b358aa7f460aaf401f7a34421.svg";
export { ForwardRef as ReactComponent };